import classNames from "classnames";
import type { HTMLAttributes, ReactNode } from "react";
import { BaseButton } from "../../../components/Button/BaseButton.tsx";
import { Icon } from "../../../components/Icon/Icon.tsx";
import { useModelUuid } from "../hooks/useModelUuid.ts";
import { useRedirectToHomepageModels } from "../hooks/useRedirectToHomepageModels.ts";
import { ModelPreview } from "./ModelPreview.tsx";

export const ModelCreationLayout = ({
  onBack,
  title,
  children,
  showModelPreview = false,
  ...rest
}: {
  onBack?: () => void;
  title?: ReactNode;
  showModelPreview?: boolean;
  children: ReactNode;
} & Omit<HTMLAttributes<HTMLDivElement>, "title">) => (
  <div className="relative w-full h-full" {...rest}>
    {onBack && (
      <ModelCreationBackButton
        onClick={onBack}
        className="absolute top-400 left-400"
      />
    )}
    <ModelCreationCloseButton className="absolute top-400 right-400" />
    <div className="h-full flex-fill overflow-y-auto flex-col items-center py-2000 gap-1200">
      <div className="flex-col gap-1000 items-center">
        {showModelPreview && <ModelPreview />}
        <div className="w-[540px] text-center text-primary heading-4xl">
          {title}
        </div>
      </div>
      {children}
    </div>
  </div>
);

const ModelCreationBackButton = ({
  className,
  onClick,
}: {
  className: string;
  onClick: () => void;
}) => (
  <BaseButton
    className={classNames(
      "rounded-100 border bg-surface-primary-rest hover:bg-surface-primary-hover",
      className,
    )}
    onClick={onClick}
  >
    <Icon name="ArrowLeft" size="sm" className="m-200" />
  </BaseButton>
);

const ModelCreationCloseButton = ({ className }: { className: string }) => {
  const modelUuid = useModelUuid();
  const redirectToHomepageModels = useRedirectToHomepageModels(modelUuid);

  return (
    <BaseButton
      onClick={redirectToHomepageModels}
      className={classNames(
        "rounded-100 border bg-surface-primary-rest hover:bg-surface-primary-hover",
        className,
      )}
    >
      <Icon name="X" size="sm" className="m-200" />
    </BaseButton>
  );
};
